import { render, staticRenderFns } from "./GraduateApplication.vue?vue&type=template&id=0ef55628&scoped=true&"
import script from "./GraduateApplication.vue?vue&type=script&lang=js&"
export * from "./GraduateApplication.vue?vue&type=script&lang=js&"
import style0 from "./GraduateApplication.vue?vue&type=style&index=0&lang=less&"
import style1 from "./GraduateApplication.vue?vue&type=style&index=1&id=0ef55628&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef55628",
  null
  
)

export default component.exports